<script setup lang="ts">
import { IndoorClimate } from '@wision/ui';
import type { SensorViewValues } from '../../models/sensorViewValues';
import { computed } from 'vue';
import type { PropType } from 'vue';
import { convertValue, extractMeta } from '../../utilities/utils';

const props = defineProps({
  viewValues: {
    type: Object as PropType<SensorViewValues>,
    required: true,
  },
});

const params = computed(() => {
  const temp = convertValue(props.viewValues.values.find(v => v.type === 'temp' && v.index === 0));
  const humidity = convertValue(props.viewValues.values.find(v => v.type === 'analog' && v.index === 0));
  const co2 = convertValue(props.viewValues.values.find(v => v.type === 'analog' && v.index === 2));
  const tvoc = convertValue(props.viewValues.values.find(v => v.type === 'analog' && v.index === 3));
  const illumination = convertValue(props.viewValues.values.find(v => v.type === 'analog' && v.index === 1));
  const pir = convertValue(props.viewValues.values.find(v => v.type === 'switch' && v.channel === 0));

  if (!temp || !humidity || !co2 || !tvoc || !illumination) return undefined;

  const timestamp = new Date(props.viewValues.updated);
  const meta = extractMeta(props.viewValues); 

  return {
    temp,
    humidity,
    co2,
    tvoc,
    illumination,
    pir,
    timestamp,
    meta
  };
});
</script>

<template>
  <div class="w-full h-[270px] flex flex-col space-y-5">
    <IndoorClimate
      v-if="params"
      v-bind="params"
    />
    <div
      v-else
      class="h-full flex justify-center items-center text-xl"
    >
      {{ $t('common.nodata')}}
    </div>
  </div>
</template>
